import { isDesktop } from "react-device-detect";
import {
    ManualInstallationInstructionsDrawer,
    ManualInstallationInstructionsDrawerProps,
    supportsManualInstallation,
} from "./ManualInstallationInstructionsDrawer";
import { IncompatibleBrowserInstructionsDrawer, isIncompatibleBrowser } from "./IncompatibleBrowserInstructionsDrawer";

export const supportsInstructions = supportsManualInstallation || isIncompatibleBrowser;

/**
 * Shows instructions drawer based on device/browser.
 */
export const InstructionsDrawerContainer = (props: Omit<ManualInstallationInstructionsDrawerProps, "isDesktop">) =>
    supportsManualInstallation ? (
        <ManualInstallationInstructionsDrawer {...props} isDesktop={isDesktop} />
    ) : (
        <IncompatibleBrowserInstructionsDrawer {...props} />
    );
